var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view", { staticClass: "router-view" }),
      _vm._v(" "),
      _vm.showPreviewImg
        ? _c("vue-picture-viewer", {
            attrs: {
              "img-data": _vm.previewImgs,
              "select-index": _vm.previewIndex,
            },
            on: {
              "close-viewer": function ($event) {
                _vm.showPreviewImg = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFixImport
        ? _c("xr-import", {
            attrs: { "process-status": _vm.crmImportStatus },
            nativeOn: {
              click: function ($event) {
                return _vm.fixImportClick.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("c-r-m-import", {
        attrs: {
          show: _vm.showCRMImport,
          "crm-type": _vm.crmType,
          props: _vm.crmProps,
          "cache-show": _vm.cacheShow,
          "cache-done": _vm.cacheDone,
        },
        on: {
          "update:show": function ($event) {
            _vm.showCRMImport = $event
          },
          "update:cacheShow": function ($event) {
            _vm.cacheShow = $event
          },
          "update:cache-show": function ($event) {
            _vm.cacheShow = $event
          },
          status: _vm.crmImportChange,
          close: _vm.crmImportClose,
        },
      }),
      _vm._v(" "),
      _vm.upgradeDialogShow
        ? _c("xr-upgrade-dialog", {
            attrs: { visible: _vm.upgradeDialogShow },
            on: {
              "update:visible": function ($event) {
                _vm.upgradeDialogShow = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }